import { makeStyles } from '@material-ui/core';
import { LogoIcon } from './LogoIcon';
import { BRAND } from '../../theme/tokens';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 10,
  },
  name: {
    color: theme.palette.navigation.selectedColor,
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: '-0.02em',
    whiteSpace: 'nowrap',
  },
  x: {
    color: BRAND.accent,
    margin: '0 1px',
  },
}));

export const LogoFull = () => {
  const classes = useStyles();
  return (
    <span className={classes.root}>
      <LogoIcon />
      <span className={classes.name}>
        bobbee<span className={classes.x}>x</span>backstage
      </span>
    </span>
  );
};
